import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";

import { usePlatformRole } from "../../../hooks/usePlatformRole";

export const Route = createFileRoute("/app/admin")({
  component: AdminLayout,
});

function AdminLayout() {
  const { isAdmin } = usePlatformRole();

  if (!isAdmin) {
    return <Navigate to="/app" />;
  }

  return (
    <div className="flex flex-col min-h-full">
      <Outlet />
    </div>
  );
}
